import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AudienceSelectorDialogComponent } from 'src/app/components/dialogs/audiences-builder/audience-selector-dialog/audience-selector-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AudienceSelectorDialogService {

  constructor(
    private modalService: NgbModal
  ) { }

  public showAudienceSelector = (acceptCallback: (audienceId: number) => void, rejectCallback?: () => void): void => {
    let ref: NgbModalRef = this.modalService.open(AudienceSelectorDialogComponent, {
      backdrop: 'static'
    });
    let output: number;

    // Get the OkDialog from the NgbModal object  
    let dialog: AudienceSelectorDialogComponent = ref.componentInstance as AudienceSelectorDialogComponent;
    
    // Set the dialog's properties
    dialog.accept = (audienceId: number) => {      
      output = audienceId;
      ref.close(1);
    };

    dialog.dismiss = () => {
      ref.dismiss(2);
    };

    ref.result.then((result) => {
      switch (result) {
        case 1:
          acceptCallback(output);
          break;
        default:
          if (rejectCallback)
            rejectCallback();
      }
    }, (reason) => {
      if (rejectCallback)
        rejectCallback();
    })
  }

}
